import { useState } from "react";
import ProductSmallTile from "../product-tile/product-small-tile";
import { server } from "../../config";
import { IProduct } from "../../model/product";
import kaosLogo from '../../public/kaos-logo.png';
import Product from "../product-page-content/product";
import styles from './front-products.module.css';
export default function FrontProducts() {
	const [fetchedRandomProducts, setFetchedRandomProducts] = useState(false);
	const [frontProducts, setFrontProducts] = useState<IProduct[] | null>(null);
	const [bestSellers, setBestSellers] = useState<IProduct[] | null>(null);
	const [kaos, setKaos] = useState<IProduct[] | null>(null);

	if (!fetchedRandomProducts) {
		setFetchedRandomProducts(true);
		var funcs$ = [
			fetch(`${server}/api/getFrontProducts`),
			fetch(`${server}/api/getBestSellers`),
		]
		Promise.all(funcs$).then(async (response) => {
			setFetchedRandomProducts(true);
			let frontProducts = await response[0].json();
			let bestSellers = await response[1].json();
			let _kaos = frontProducts.filter((p: IProduct) => p.affiliate == 'KAOS');
			frontProducts = frontProducts.filter((p: IProduct) => p.affiliate !== 'KAOS');
			setKaos(shuffleArray(_kaos));
			setBestSellers(shuffleArray(bestSellers));
			setFrontProducts(shuffleArray(frontProducts));
		}).catch((error) => {
			console.error(error);
			setFetchedRandomProducts(true);
		});
	}

	function shuffleArray(array: any[]) {
		for (var i = array.length - 1; i >= 0; i--) {
			var j = Math.floor(Math.random() * (i + 1));
			var temp = array[i];
			array[i] = array[j];
			array[j] = temp;
		}
		return array;
	}
	return (
		<>
			<h2>Vår nye partner <img src={kaosLogo.src} alt="Kaos" style={{'maxHeight' : '32px'}}/></h2>
			<section>
			{
					kaos?.map && kaos?.map(p =>
						<ProductSmallTile detailsPath={`/produkter/${p.brand}`} product={p} size='normal' key={p._id} />
					)
				}
			</section>
			<h2>Utvalgte produkter</h2>
			<section>
				{
					frontProducts?.map && frontProducts?.map(p =>
						<ProductSmallTile detailsPath={`/produkter/${p.brand}`} product={p} size='normal' key={p._id} />
					)
				}
			</section>
			
			<h2>Bestselgere</h2>
			<section>
				{bestSellers?.length && <div className={styles.frontProductWrapper}><Product product={{...bestSellers[0], longDescription: `${bestSellers[0].shortDescription}`}} usedInFront={true} /></div>}
				{
					bestSellers?.map && bestSellers?.map(p =>
						<ProductSmallTile detailsPath={`/produkter/${p.brand}`} product={p} size='normal' key={p._id} />
					)
				}
				
			</section>
			<div className="hideInMobile hideOnPad">

			</div>
		</>
	);
}